import { Injectable } from '@angular/core';
import { ExternalUrlObject } from 'src/app/models/config/external-url-object.model';
import { AppService } from 'src/app/app.service';
import { isNullOrUndefined } from 'util';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  appData: any;

  constructor(
    private httpClient: HttpClient,
    appService: AppService
  ) {
    this.appData = appService.settings;
  }

  getExternalUrls(): Observable<Array<ExternalUrlObject>> {
    return this.httpClient.get<any>(`${this.appData.webApi}/config/external/url`)
      .pipe(
        map(externalUrlsData => {
          const externalUrls: Array<ExternalUrlObject> = new Array<ExternalUrlObject>();

          if (!isNullOrUndefined(externalUrlsData) && externalUrlsData.length > 0) {
            for (const externalUrlData of externalUrlsData) {
              externalUrls.push(new ExternalUrlObject(externalUrlData.name, externalUrlData.value));
            }
          }

          return externalUrls;
        }),
        catchError(() => of(new Array<ExternalUrlObject>())),
      );
  }

  public getInventoryUrl(externalURLs: Array<ExternalUrlObject>): string {
    let result: string;
    if (isNullOrUndefined(externalURLs) || externalURLs.length == 0) return "";

    for (let externalURL of externalURLs) {
      if (externalURL.name == 'inventory') {
        result = externalURL.value;
        break;
      }
    }

    return result;
  }
}
